import http from "./http";

// Mensagem Pos-Consulta: geracao e envio passam pelo Laravel (auth Bearer), que
// extrai as recomendacoes do resumo, chama a IA no nutria-comunicacao e envia.
// Substitui a chamada direta ao servico standalone (VUE_APP_PAUTA_URL) neste fluxo.

/**
 * Gera a mensagem pos-consulta a partir do resumo da consulta.
 * @param {object} params
 * @param {string} params.summary       Resumo estruturado (ou recomendacoes) da consulta.
 * @param {string} [params.patientName] Nome do paciente (para personalizar a saudacao).
 * @returns {Promise<{success:boolean, data?:{subject_email:string,email_message:string,patient_name_used:string}, message?:string}>}
 */
export async function gerarMensagemPosConsulta({ summary, patientName = null }) {
  const { data } = await http.post("/api/post-consultation-message/generate", {
    summary,
    patient_name: patientName,
  });
  return data;
}

/**
 * Envia a mensagem por e-mail para o paciente.
 * @returns {Promise<{success:boolean, message?:string}>}
 */
export async function enviarMensagemPorEmail({ patientId, subject, message }) {
  const { data } = await http.post("/api/post-consultation-message/send-email", {
    patient_id: patientId,
    subject,
    message,
  });
  return data;
}

/**
 * Envia a mensagem por WhatsApp, reusando o fluxo de chat ja existente.
 * @returns {Promise<{success:boolean}>}
 */
export async function enviarMensagemPorWhatsapp({ patientId, message }) {
  const { data } = await http.post("/api/patient-chat/send", {
    patient_id: patientId,
    message,
  });
  return data;
}
